import React from 'react'
import PropTypes from 'prop-types'
import Link from 'next/link'
import useTranslation from 'next-translate/useTranslation'
import { getGroups } from 'SRC/modules/groups/selectors'
import { getUserTypes } from 'SRC/modules/common/selectors'
import { connect } from 'react-redux'
import { Column } from '../Column'
import { columns } from '../data/columns'
import { Apps } from '../Apps'
import { SocialLinks } from '../SocialLinks'
import translations from '../../../../../../../public/data/translations.json'

const Menu = ({ groups, userTypes }) => {
  const { t, lang } = useTranslation('common')

  const locale = lang?.toUpperCase() || 'ME'

  // columns.map(column => {
  //   if (column.apps) return <Apps key='apps' />

  //   return (
  //     <Column key={column.id} {...column}>
  //       {column.child}
  //     </Column>
  //   )
  // })

  return (
    <>
      <div className='kategorije-oglasa'>
        <span className='footer-column-title'>{t(`footer_column1_title`)}</span>

        <ul>
          {groups.map((group) => (
            <li key={group.id}>
              <Link
                href={{ pathname: '/category', query: { category: group.seo } }}
                as={group.seo}
              >
                <a>
                  {t(`footer_column1_${group.id}_title`)}
                </a>
              </Link>
            </li>
          ))}


          <li key={'ostale_kategorije'}>
            <a href={translations.kategorije[locale]}>
              {t('footer_column1_all_categories_title')}
            </a>
          </li>
        </ul>
      </div>

      <div className='navigacija'>
        <span className='footer-column-title'>{t(`footer_column2_title`)}</span>

        <ul>
          {userTypes.filter((userType) => userType.id !== 1).map((userType) => (
            <li key={userType.id}>
              <Link
                href={{
                  pathname: '/users',
                  query: {
                    userType: userType.seo
                  }
                }}
                as={userType.seoPluLocalized}
              >
                <a>
                  {userType.name}
                </a>
              </Link>
            </li>
          ))}

          <li key={'auto_novosti'}>
            <a href='https://autonovosti.com'>
              {t('footer_column2_17_title')}
            </a>
          </li>

          <li key={'marketing'}>
            <a href={locale === 'ME' ? '/marketing' : `/${locale.toLocaleLowerCase()}/marketing`}>
              {t('footer_column2_19_title')}
            </a>
          </li>

          <li key={'mapa_sajta'}></li>
        </ul>
      </div>

      <div className='vas-autodiler'>
        <span className='footer-column-title'>{t(`footer_column3_title`)}</span>

        <ul>
          <li key='login'>
            <Link
              href={{
                pathname: '/profile',
              }}
              as='/profil'
            >
              <a>
                {t('footer_column3_21_title')}
              </a>
            </Link>
          </li>

          <li key='contact'>
            <a href={`/${locale !== 'ME' ? `${locale.toLocaleLowerCase()}/` : ''}${translations.staticPages[locale].kontakt.slug}`}>
              {translations.staticPages[locale].kontakt.title}
            </a>
          </li>

          <li key='pomoc'>
            <a href={`/${locale !== 'ME' ? `${locale.toLocaleLowerCase()}/` : ''}${translations.staticPages[locale].pomoc.slug}`}>
              {translations.staticPages[locale].pomoc.title}
            </a>
          </li>

          <li key='uslovi-koriscenja'>
            <a href={`/${locale !== 'ME' ? `${locale.toLocaleLowerCase()}/` : ''}${translations.staticPages[locale]['uslovi-koriscenja'].slug}`}>
              {translations.staticPages[locale]['uslovi-koriscenja'].title}
            </a>
          </li>

          <li key='politika-privatnosti'>
            <a href={`/${locale !== 'ME' ? `${locale.toLocaleLowerCase()}/` : ''}${translations.staticPages[locale]['politika-privatnosti'].slug}`}>
              {translations.staticPages[locale]['politika-privatnosti'].title}
            </a>
          </li>

          <li key='prava-potrosaca'>
            <a href={`/${locale !== 'ME' ? `${locale.toLocaleLowerCase()}/` : ''}${translations.staticPages[locale]['prava-potrosaca'].slug}`}>
              {translations.staticPages[locale]['prava-potrosaca'].title}
            </a>
          </li>

          <li key='sigurna-trgovina'>
            <a href={`/${locale !== 'ME' ? `${locale.toLocaleLowerCase()}/` : ''}${translations.staticPages[locale]['sigurna-trgovina'].slug}`}>
              {translations.staticPages[locale]['sigurna-trgovina'].title}
            </a>
          </li>
        </ul>

        <SocialLinks />
      </div>

      <Apps />
    </>
  )
}

const mapStateToProps = (state) => ({
  groups: getGroups(state),
  userTypes: getUserTypes(state)
})

Menu.prototype = {
  groups: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    seo: PropTypes.string.isRequired
  })).isRequired,
  userTypes: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    seoLocalized: PropTypes.string.isRequired,
    seoPluLocalized: PropTypes.string.isRequired
  })).isRequired
}

Menu.defaultProps = {
  groups: [],
  userTypes: []
}

export default connect(mapStateToProps)(Menu)
